<header class="header">
  <nav class="navbar navbar-expand-lg">
    <div class="container-fluid">
      <button class="open-main-nav text-white" type="button" (click)="toggleMainNav()">☰</button>
      <div class=" justify-content-end" >
        <user-navbar/>
      </div>
    </div>
  </nav>
</header>



